import classNames from 'classnames'
import React, { forwardRef, ForwardedRef } from 'react'

export type SwitchButtonProps = Exclude<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type' | 'role' | 'value'
> & {
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>
}

function SwitchButton(
  { labelProps, ...nativeInputProps }: SwitchButtonProps,
  ref?: ForwardedRef<HTMLInputElement>,
) {
  const { className, checked, disabled } = nativeInputProps
  return (
    <label
      {...labelProps}
      className={classNames(
        'relative flex justify-between items-center group cursor-pointer',
        { 'cursor-not-allowed': disabled },
        labelProps?.className,
      )}>
      <input
        type="checkbox"
        role="switch"
        ref={ref}
        {...nativeInputProps}
        className={classNames('hidden', className)}
      />
      <span
        className={classNames(
          'w-[44px] h-7 flex items-center flex-shrink-0 p-0.5 rounded-full transition-colors duration-300',
          checked ? 'bg-primary' : 'bg-text500',
        )}>
        <i
          className={classNames(
            'w-6 h-6 relative bg-white rounded-full shadow-md transition-[left] duration-300',
            checked ? 'left-m' : 'left-0',
          )}
        />
      </span>
    </label>
  )
}

export default forwardRef(SwitchButton)
